const averageOf = (numbers: number[]) => {
    if (numbers.length === 0) return 0;
    return numbers.reduce((prevValue, value) => prevValue + value, 0) / numbers.length
}

export default averageOf;